import React, {Fragment} from 'react';

import {gt} from 'app/utils/i18n';

import type {StepViewFieldProps} from '../commonprops';
export const StepViewFileField = ({field}: StepViewFieldProps) => (
  <Fragment>
    <label>{field.label}</label>
    <div className="input-group">
      <input
        className="form-control ext-black-50"
        disabled
        type="text"
        value={gt('File picker will be shown here.')}
      />
      <div className="input-group-append">
        <span className="input-group-text">{gt('Browse')}</span>
      </div>
    </div>
  </Fragment>
);
